import React, { useContext, useState, Component } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import YoutubeResult from "./youtube";

import RoomService from "../../../service/rooms-service";
import PlaylistService from "../../../service/playlist-service";
import ToastService from "../../../service/toast-service";
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Theme } from "../../../theme/theme-provider";
import {
  Box,
  Text,
  Col,
  Row,
  SearchBox,
  VGap,
  ButtonGroup,
} from "../../../comps";

const Wrapper = styled(Col)`
  width: 100%;
  /* border: 2px solid red; */
  padding-left: 30px;
  padding-right: 30px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const Line = styled(Box)`
  width: 100%;
  height: 1px;
  background: #d7e0da;
`;

const StyledText = styled(Text)`
  font-family: "Lucida Console", Courier, monospace;
  -moz-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
  -webkit-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
  -o-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
  -ms-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
  transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
`;

const ButtonsWrapper = styled(Box)`
  width: 100%;
  height: 50px;
`;

const Actions = ({ songs, isModalView, to, handleAddSongs }) => {
  if (isModalView) {
    const addAll = (
      <Button
        style={{ flex: 1, color: "#d7e0da" }}
        onClick={() => {
          ToastService.infoToast(
            `adding all to ${to === "room" ? `room's Queue` : `playlist`}`
          );
          handleAddSongs(songs);
        }}
      >
        {`Add all songs to ${to === "room" ? `room's Queue` : `playlist`}`}
      </Button>
    );
    return <ButtonGroup buttons={[addAll]} color="#d7e0da" outline={true} />;
  } else {
    const createNew = (
      <Button
        style={{ flex: 1, color: "#d7e0da" }}
        onClick={() => {
          ToastService.infoToast("creating new playlist");
          PlaylistService.createNewPlaylist({ songs, name: "random" });
        }}
      >
        save as a new playlist
      </Button>
    );
    const saveToExisting = (
      <Button style={{ flex: 1, color: "#d7e0da" }}>
        add all to existing playlist
      </Button>
    );
    const addToFav = (
      <Button style={{ flex: 1, color: "#d7e0da" }}>
        Add all to favourites
      </Button>
    );

    return (
      <ButtonGroup
        buttons={[createNew, saveToExisting, addToFav]}
        color="#d7e0da"
        outline={true}
      />
    );
  }
};

export default ({ songs, isModalView, to, handleAddSongs }) => {
  const createNewPlaylist = () => {};
  // create new playlist

  return (
    <Wrapper>
      <StyledText
        color="#d7e0da"
        width="50%"
        fontSize={"22px"}
        fontWeight={400}
      >{`Successfully imported 43 songs`}</StyledText>
      <VGap height="8px" />
      <Line />
      <VGap height="16px" />
      <ButtonsWrapper>
        <Actions
          isModalView={isModalView}
          songs={songs}
          to={to}
          handleAddSongs={handleAddSongs}
        />
      </ButtonsWrapper>
    </Wrapper>
  );
};
